import axios from "axios";
import { ROOT_SERVER } from "../utilities/Static";
export default async function LoginFunction(identifier) {
  const { data: response } = await axios.post(`${ROOT_SERVER}login`, {
    email: identifier,
    identifier,
  });
  return response;
}
